module.exports = __webpack_public_path__ + "static/3-89f17ef310ce60760f1f61de7b962a43.jpeg";